import React, { useState, useEffect, useMemo } from 'react';
import {
    Modal, Paper, Typography, Grid, Table,
    TableBody, TableCell, Box, TableContainer, TableHead,
    TableRow, Checkbox, TextField, Badge, IconButton, Button,
    Dialog, DialogTitle, DialogContent, DialogActions,
    Autocomplete
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { CircleAlertIcon, CircleCheckBigIcon, CirclePlusIcon, Trash2Icon } from 'lucide-react';
import Swal from 'sweetalert2';
import { setCargaDatos } from "../../Redux/V2/ContratoRedux";
import { setCargaGeneral } from "../../Redux/GeneralDuck";
import Select from 'react-select'
import { styleModalValidaCausa } from '../styles/modal'
import Cookies from 'universal-cookie';
import { FlareSharp } from '@mui/icons-material';

const TareasCausas = ({ from }) => {
    const dispatch = useDispatch()
    const servicios = useSelector((store) => store.contratoV2.contrato)
    const entrevista = useSelector((store) => store.contratoV2.Entrevista)
    const causas = useSelector((store) => store.contratoV2.Causas)
    const tareasCausa = useSelector((store) => store.contratoV2.TareasCausa)
    const actualizacion = useSelector((store) => store.contratoV2.Actualizacion)
    const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
    const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
    const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);
    const contratoValidado = useSelector((store) => store.contratoV2.ContratoValidado);
    const acreedores = useSelector((store) => store.contratoV2.Acreedores || []);
    const defendido = useSelector((store) => store.contratoV2.Defendido)

    const cookies = new Cookies();

    //const tribunales = useSelector((store) => store.general.tribunales)
    
    const tribunales = useSelector((store) => store.contratoV2.Tribunales || []);
    
    //const grupos = useSelector((store) => store.general.grupos)
    const grupos = useSelector((store) => store.contratoV2.Grupos)

    const [selectedTasksCase, setSelectedTasksCase] = useState({}); // Inicialmente vacío
    const [causaAbierta, setCausaAbierta] = useState({})
    const [showInitialCase, setShowInitialCase] = useState(false)
    const [disabledComponent, setDisabledComponent] = useState(false);
    const [causasList, setCausasList] = useState([]);
    const [serviciosList, setServiciosList] = useState([]);

    /** TAREAS  en public task.js*/
    const [CASE_TASK, setCASE_TASK] = useState([])
    const [User_CASES, setUser_CASES] = useState([])



    const [newCausa, setNewCausa] = useState({ rut: null, rol: null, nombreCausa: null, tribunal: null, demandante: null, servicio: null, contractServiceId: null });
    const [dialogOpen, setDialogOpen] = useState(false)
    const ShowAddCausa = (servicio, contractServiceId) => {
        setNewCausa({ rut: defendido.identifier, rol: null, tribunal: null, nombreCausa: null, tribunal: null, demandante: null, servicio, contractServiceId })
        setDialogOpen(true)
    }


    const bloqueadoTotalmente =
        !!contratoCancelado?.cancelado ||
        !!contratoFiniquitado?.finiquitado

    useEffect(() => {
        //setCASE_TASK(window.CASE_TASK)
        setUser_CASES(window.USER_CASES)


        dispatch(setCargaDatos("Tribunales", "get"))
        dispatch(setCargaDatos("Grupos", "get"))

        //dispatch(setCargaGeneral("grupos"))


        if (entrevista?.contractId != null && (servicios == null || servicios == undefined || servicios.length == 0)) {
            console.log(4)
            dispatch(setCargaDatos("contrato", "get", entrevista.contractId));
        }
    }, [entrevista])
    //para actualizacion traer servicios y causas

    useEffect(() => {
        //tareas de la causa abierta en la modal
        if (actualizacion?.actualizacion?.status == 1 && actualizacion?.actualizacion?.type == 1) { // bloqueo solo para actualizacion normal
            setDisabledComponent(true)
        }
        setSelectedTasksCase(tareasCausa)
    }, [tareasCausa])


    useEffect(() => {

        if (actualizacion?.actualizacion?.status == 1 && actualizacion?.actualizacion?.type == 2) { //actualizacion en curso, cargar los servicios de la actualizacion
            if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
                const _causasAct = actualizacion.actualizacionModelos.find(obj => obj.model == "causas");
                if (_causasAct != null) {
                    setCausasList(JSON.parse(_causasAct.json) || [])
                    return
                }
            }
        }
        setCausasList(causas)
    }, [causas, actualizacion])

    useEffect(() => {

        if (actualizacion?.actualizacion?.status == 1 && actualizacion?.actualizacion?.type == 2) { //actualizacion en curso, cargar los servicios de la actualizacion
            if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
                const _causasAct = actualizacion.actualizacionModelos.find(obj => obj.model == "servicio");
                if (_causasAct != null) {
                    setServiciosList(JSON.parse(_causasAct.json).servicios || [])
                    return
                }
            }
        }
        setServiciosList(servicios)
    }, [servicios, actualizacion])



    const abrirCausaParaTareas = async (causa, servicio, index) => {
        setShowInitialCase(true)
        if (causa.grupoId != undefined && causa.grupoId > 0) {
            var list = await dispatch(setCargaDatos("Tareas", "get", causa.grupoId));
            setCASE_TASK(list);
        } else
            setCASE_TASK([])

        var aux = { ...causa }
        if (
            actualizacion?.actualizacion?.status === 1 &&
            actualizacion?.actualizacion?.createAt && causa?.createAt &&
            new Date(causa.createAt) < new Date(actualizacion.actualizacion.createAt)
        ) {
            aux.block = true;
        } else
            aux.block = false;

        aux.servicio = servicio
        setCausaAbierta(aux)

        await dispatch(setCargaDatos("TareasCausa", "get", causa.id))
    };

    const setChangGroupCausa = async (e) => {
        var list = await dispatch(setCargaDatos("Tareas", "get", e.value));
        setCASE_TASK(list);
        //if(causaAbierta.grupoId != undefined && causaAbierta.grupoId > 0)
        setCausaAbierta((prev) => ({ ...prev, grupoId: e.value }))
    }

    const handleExtraChangeCase = (comentario, task) => {
        setSelectedTasksCase((prevState) => {
            const key = `${causaAbierta.id}-${causaAbierta.servicio ?? causaAbierta.serviceId}`;
            const prevTasks = prevState[key] || []; // Asegura que siempre sea un array
            return {
                ...prevState,
                [key]: prevTasks.map((t) =>
                    t.name === task.name ? { ...t, extra: comentario } : t
                ),
            };
        });
    };

    const handleCheckboxChangeCase = (event, task) => {
        setSelectedTasksCase((prevState) => {
            const key = `${causaAbierta.id}-${causaAbierta.servicio ?? causaAbierta.serviceId}`;
            const existingTasks = prevState[key] || [];

            if (event.target.checked) {
                // Agregar tarea seleccionada con nombre, usuario vacío y descripción
                return {
                    ...prevState,
                    [key]: [...existingTasks, { name: task.name, description: task.description, extra: "", userId: 0 }],
                };
            } else {
                // Remover tarea deseleccionada
                return {
                    ...prevState,
                    [key]: existingTasks.filter((t) => t.name !== task.name),
                };
            }
        });
    };

    const handleUserChangeCase = (event, task) => {
        setSelectedTasksCase((prevState) => {
            const key = `${causaAbierta.id}-${causaAbierta.servicio ?? causaAbierta.serviceId}`;
            const prevTasks = prevState[key] || []; // Asegura que siempre sea un array
            return {
                ...prevState,
                [key]: prevTasks.map((t) =>
                    t.name === task.name ? { ...t, userId: Number(event.target.value) } : t
                ),
            };
        });
    };

    const showDeleteCausa = (row) => {
        Swal.fire({
            title: '¿Está seguro que desea eliminar la causa?',
            text: "Esta acción no se puede deshacer.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {

                var payload = { interviewId: entrevista.id, Id: row.id }

                if (actualizacion?.actualizacion?.status == 1 && actualizacion?.actualizacion?.type == 2) { //si es cambio de estrategia en curso
                    var _actPayload = {
                        json: JSON.stringify(payload),
                        model: "causaTask/delete",
                        actualizacionId: actualizacion.actualizacion.id,
                    }
                    var exito = await dispatch(setCargaDatos("Actualizacion", "put", _actPayload));
                    return
                }
                var success = await dispatch(setCargaDatos("Causas", "delete", { interviewId: entrevista.id, Id: row.id }))
                return;
            }
        })
    }

    const guardarTeareasDeCausa = async () => {
        if (!causaAbierta) return;
        if (!causaAbierta.grupoId) {
            Swal.fire({ title: 'No Agrego el Grupo', allowOutsideClick: true })
            return;
        }
        console.log(causasList)

        if (actualizacion?.actualizacion?.status == 1 && actualizacion?.actualizacion?.type == 2) { // si es cambio de estrategia en curso
            //asigno tareas a la causa, ya viene con el grupo
            var _causaAux = { ...causaAbierta }
            _causaAux.tareas = selectedTasksCase[`${causaAbierta.id}-${causaAbierta.servicio ?? causaAbierta.serviceId}`]

            var payloadUpdate = { ...causasList }

            payloadUpdate.causasGcc = causasList.causasGcc.map(obj =>
                obj.rol === _causaAux.rol && obj.codTribunal === _causaAux.codTribunal
                    ? { ...obj, ..._causaAux } // actualiza solo ese objeto
                    : obj // deja el resto igual
            );

            var _actPayload = {
                json: JSON.stringify(payloadUpdate),
                model: "causas",
                actualizacionId: actualizacion.actualizacion.id,
            }
            var exito = await dispatch(setCargaDatos("Actualizacion", "put", _actPayload));
            setShowInitialCase(false);
            return
        }
        //return;

        var payload = {
            CausasContratoId: causaAbierta.id,
            groupId: causaAbierta.grupoId,
            idStatus: 2,
            contractServiceId: causaAbierta.contractServiceId,
            contractId: entrevista.contractId,
            selectedTasksCase: JSON.stringify(selectedTasksCase[`${causaAbierta.id}-${causaAbierta.servicio ?? causaAbierta.serviceId}`] || []),
            nameTasksCase: `${causaAbierta.id}-${causaAbierta.servicio ?? causaAbierta.serviceId}`,
        }

        dispatch(setCargaDatos("Causas", "put", payload))
        setShowInitialCase(false);
    }

    const makeNegId = (() => {
        let seq = 0;
        return () => -(Date.now() * 1000 + (seq = (seq + 1) % 1000));
    })();




    const tienePermisosValidacion = (() => {
        const firmado =
            contratoFirmado?.firmado === true ||
            contratoFirmado?.firmado === 'true';

        if (!firmado) return false;

        let rolId = NaN;
        try {
            const raw = cookies.get('rolId');
            if (raw != null) rolId = parseInt(raw, 10);
        } catch { /* noop */ }
        const lista = Array.isArray(window?.ROLID_VALIDA) ? window.ROLID_VALIDA : [];
        return !Number.isNaN(rolId) && lista.includes(rolId);
    })();

    const handleInputChange = (e) => {
        if (bloqueadoTotalmente) return;
        const { name, value } = e.target;
        setNewCausa(prev => ({ ...prev, [name]: value }));
    };
    const acreedoresUniq = useMemo(() => {
        const seen = new Set();
        if (!Array.isArray(acreedores)) return []
        return acreedores.filter(a => {
            const k = (a.id ?? a.name?.toLowerCase().trim());
            if (seen.has(k)) return false;
            seen.add(k);
            return true;
        });
    }, [acreedores]);

    const handleAddCausaDesdeDialog = async () => {
        if (bloqueadoTotalmente) return;
        if (!newCausa.rut || !newCausa.rol || !newCausa.nombreCausa || !newCausa.tribunal || !newCausa.demandante) {
            Swal.fire('Campos incompletos', 'Por favor, completa todos los campos requeridos.', 'warning');
            return;
        }
        const causaParaAgregar = {
            rol: newCausa.rol,
            nameCaratulado: newCausa.nombreCausa,
            identifier: newCausa.rut,
            tribunal: newCausa.tribunal.label,
            codTribunal: newCausa.tribunal.id,
            demandante: newCausa.demandante.name,
            id: 0,
            proc: '',
            etapa: '',
            estadoProc: '',
            contractServiceId: newCausa.contractServiceId,
            name: newCausa.nombreCausa,
            uiId: `manual-${Date.now()}`,
            contractId: entrevista.contractId,
            interviewId: entrevista.id
        };

        const exito = await dispatch(setCargaDatos("Causas", "patch", causaParaAgregar));
        if (exito) {
            Swal.fire({ icon: 'success', title: '¡Guardado!', text: 'La selección ha sido actualizada.', showConfirmButton: false, timer: 1500 });
            dispatch(setCargaDatos("Causas", "get", entrevista.id));
        } else {
            Swal.fire({ icon: 'error', title: 'Error al guardar', text: 'El servidor no pudo procesar la solicitud.' });
        }



        Swal.fire('¡Agregada!', 'La nueva causa ha sido añadida a la lista.', 'success');
        setDialogOpen(!dialogOpen)
        //handleCloseDialog();


    };

    const desactivar = (row) => {
        if (bloqueadoTotalmente)
            return true;
        if (disabledComponent)
            return true;

        if (contratoValidado?.validado) {
            if (actualizacion?.actualizacion?.type == 2 && actualizacion?.actualizacion?.status == 2 && actualizacion?.actualizacion?.validation == false) {
                if (row == "agregar_causa") return false;

                if (new Date(row.createAt) > new Date(actualizacion.actualizacion.createAt)) {
                    return false;
                }
            }
            return true;
        }
        else if (!contratoValidado?.validado && row == "agregar_causa")
            return false;
        else if (!tienePermisosValidacion) // no tienen permisos
            return true;
        return false;
    }

    return (
        <>
            {/* LISTA DE SERVICIOS CON SUS CAUSA */}
            {serviciosList.map(servicio => (
                <>
                    <Typography sx={{ mt: 3 }} variant="h6" component="h1"> Servicio: {servicio.name}</Typography>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Rol</TableCell>
                                    <TableCell align="right">Caratulado</TableCell>
                                    <TableCell align="right">Tribunal</TableCell>
                                    <TableCell align="right">Demandante</TableCell>
                                    <TableCell align="right">Estado</TableCell>
                                    <TableCell align="right">Validación</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {causasList?.causasGcc?.map((row, index) => (
                                    (servicio.idService == row.serviceId) ?
                                        <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align="right">{row.rol}</TableCell>
                                            <TableCell align="right">{row.nameCaratulado}</TableCell>
                                            <TableCell align="right">{row.tribunal}</TableCell>
                                            <TableCell align="right">{row.demandante}</TableCell>
                                            <TableCell align="right">
                                                <Badge
                                                    badgeContent={(row.idStatus == 2 || row.grupoId > 0) ? "Validada" : "Pendiente"}
                                                    color={(row.idStatus == 2 || row.grupoId > 0) ? "success" : "warning"}
                                                />
                                            </TableCell>
                                            <TableCell align="right">
                                                {(actualizacion?.actualizacion?.status == 1 && actualizacion?.actualizacion?.type == 2 && row.id == 0) ?
                                                    <>
                                                        <IconButton
                                                            disabled={false}
                                                            onClick={() => abrirCausaParaTareas(row, servicio.name, index)}
                                                            color={(row.idStatus == 2 || row.grupoId > 0) ? "success" : "warning"}>
                                                            {(row.idStatus == 2 || row.grupoId > 0) ? <CircleCheckBigIcon /> : <CircleAlertIcon />}
                                                        </IconButton>

                                                        <Button onClick={() => showDeleteCausa(row)} > <Trash2Icon style={{ marginLeft: '8px' }} /> </Button>
                                                    </>
                                                    :
                                                    <>
                                                        <IconButton
                                                            disabled={desactivar(row)}
                                                            onClick={() => abrirCausaParaTareas(row, servicio.name, index)}
                                                            color={row.idStatus == 2 ? "success" : "warning"}>
                                                            {row.idStatus == 2 ? <CircleCheckBigIcon /> : <CircleAlertIcon />}
                                                        </IconButton>

                                                        <Button disabled={desactivar(row)}
                                                            onClick={() => showDeleteCausa(row)} > <Trash2Icon style={{ marginLeft: '8px' }} />
                                                        </Button>
                                                    </>}

                                            </TableCell>
                                        </TableRow>
                                        : null
                                ))}
                                <TableRow>
                                    <TableCell colSpan={5}></TableCell>
                                    <TableCell>
                                        <Button
                                            onClick={() => ShowAddCausa(servicio.name, servicio.contractServiceId)}
                                            disabled={desactivar("agregar_causa")}
                                        >
                                            Agregar Causa
                                            <CirclePlusIcon style={{ marginLeft: '8px' }} />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer >
                </>
            ))
            }

            <Modal
                open={showInitialCase}
                onClose={() => setShowInitialCase(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleModalValidaCausa}>
                    <div style={{ background: "white", padding: "16px", borderRadius: "8px", width: "100%", margin: "auto" }}>
                        <Typography>Detalles de la Causa</Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={6}>
                                <p><strong>Rol:</strong> {causaAbierta?.rol}</p>
                                <p><strong>Caratulado:</strong> {causaAbierta?.nombre}</p>
                                <p><strong>Tribunal:</strong> {causaAbierta?.tribunal}</p>
                                <p><strong>Demandante:</strong> {causaAbierta?.demandante}</p>
                                <p><strong>Estado:</strong> {causaAbierta?.idStatus == 2 ? "Validada" : "Pendiente"}</p>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <h4>Seleccionar Gruposs</h4>
                                <Select
                                    onChange={(e) => setChangGroupCausa(e)}
                                    options={grupos.map(g => ({ value: g.id, label: g.name }))}
                                    className="basic-single mb-4"
                                    classNamePrefix="select"
                                    value={grupos.map(g => ({ value: g.id, label: g.name })).find(opt => opt.value === causaAbierta.grupoId) || null}
                                    isClearable={false}
                                    isRtl={false}
                                    isSearchable={true}
                                    isDisabled={(contratoValidado?.validado && causaAbierta?.block) || !tienePermisosValidacion || bloqueadoTotalmente || causaAbierta?.block}
                                />

                            </Grid>
                        </Grid>
                        <Box>
                            <hr />
                            <h5>Seleccionar Tareas causa</h5>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Seleccionar</TableCell>
                                        <TableCell>Tarea</TableCell>
                                        <TableCell>Descripción</TableCell>
                                        <TableCell >Comentario</TableCell>
                                        <TableCell>Usuario Asignado</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        //tttt
                                    }
                                    {CASE_TASK?.map((task) => {
                                        const key = `${causaAbierta.id}-${causaAbierta.servicio ? causaAbierta.servicio : causaAbierta.serviceId}`;
                                        const isChecked = selectedTasksCase[key]?.some((t) => t.name === task.name) || false;
                                        const selectedUser = selectedTasksCase[key]?.find((t) => t.name === task.name)?.userId || "";
                                        const selectedExtra = selectedTasksCase[key]?.find((t) => t.name === task.name)?.extra || "";
                                        return (
                                            <TableRow key={task.name}>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={isChecked}
                                                        disabled={(contratoValidado?.validado && causaAbierta?.block) || !tienePermisosValidacion || bloqueadoTotalmente || causaAbierta?.block}
                                                        onChange={(e) => handleCheckboxChangeCase(e, task)}
                                                    />
                                                </TableCell>
                                                <TableCell>{task.name}</TableCell>
                                                <TableCell style={{ width: '25%' }}>{task.description}...</TableCell>
                                                <TableCell style={{ width: '25%' }}>
                                                    <TextField
                                                        label="Comentario"
                                                        value={selectedExtra}
                                                        onChange={(e) => handleExtraChangeCase(e.target.value, task)}
                                                        variant="outlined"
                                                        fullWidth
                                                        size='small'
                                                        disabled={(contratoValidado?.validado && causaAbierta?.block) || !tienePermisosValidacion || bloqueadoTotalmente || causaAbierta?.block}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <select
                                                        disabled={(contratoValidado?.validado && causaAbierta?.block) || !tienePermisosValidacion || bloqueadoTotalmente || causaAbierta?.block}
                                                        value={selectedUser}
                                                        onChange={(e) => handleUserChangeCase(e, task)}
                                                    >
                                                        {User_CASES?.map((user) => (
                                                            <option key={user.userId} value={user.userId}>
                                                                {user.Name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </Box>


                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                            <Button disabled={causaAbierta?.block} variant="contained" color="secondary" onClick={() => setShowInitialCase(false)}> Cerrar </Button>
                            <Button
                                disabled={(contratoValidado?.validado && causaAbierta?.block) || !tienePermisosValidacion || bloqueadoTotalmente || causaAbierta?.block}
                                variant="contained" color="primary" onClick={guardarTeareasDeCausa} style={{ marginLeft: "10px" }}> Guardar Cambios </Button>
                        </div>
                    </div>
                </Box>
            </Modal>


            <Dialog open={dialogOpen} onClose={() => setDialogOpen(!dialogOpen)} maxWidth="md">
                <DialogTitle>Agregar causa a servicio {newCausa.servicio}</DialogTitle>
                <DialogContent>
                    {
                        //JSON.stringify(newCausa)
                    }
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={6}>
                            <TextField required fullWidth name="rut" label="Rut" value={newCausa.rut} disabled={true} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField required fullWidth name="rol" label="Rol" value={newCausa.rol} onChange={handleInputChange} autoFocus disabled={bloqueadoTotalmente} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                fullWidth
                                options={tribunales}
                                getOptionLabel={(option) => option.label || ''}
                                value={newCausa.tribunal}
                                onChange={(e, val) => !bloqueadoTotalmente && setNewCausa(p => ({ ...p, tribunal: val }))}
                                renderInput={(params) => <TextField {...params} label="Seleccione Tribunal" required disabled={bloqueadoTotalmente} />}
                                disabled={bloqueadoTotalmente}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField required fullWidth name="nombreCausa" label="Nombre Causa - Caratula" value={newCausa.nombreCausa} onChange={handleInputChange} disabled={bloqueadoTotalmente} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                fullWidth
                                options={acreedoresUniq}
                                getOptionLabel={(option) => option?.name ?? ""}
                                // Muy importante para que no “re-renderice” comparando por referencia:
                                isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                value={newCausa.demandante ?? null} // debe ser un objeto de options o null
                                onChange={(e, val) => !bloqueadoTotalmente && setNewCausa(p => ({ ...p, demandante: val }))}
                                // Asegura key única en cada <li>:
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>{option.name}</li>
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} label="Seleccione un demandante" required disabled={bloqueadoTotalmente} />
                                )}
                                disabled={bloqueadoTotalmente}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ p: '16px 24px' }}>
                    <Button onClick={() => setDialogOpen(!dialogOpen)} variant="outlined" color="secondary">Cerrar</Button>
                    <Button onClick={handleAddCausaDesdeDialog} variant="contained" color="primary" disabled={bloqueadoTotalmente}>Crear</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TareasCausas;